import { useEffect, useState } from 'react';
import { PLACEMENT_CHANGED_EVENT, readFileReviewPanelPlacement } from './fileReviewUiPrefs';
import type { FileReviewDocumentKind, FileReviewPanelPlacement } from './types';

export function useFileReviewPanelPlacement(
  documentType?: FileReviewDocumentKind
): FileReviewPanelPlacement {
  const [placement, setPlacement] = useState<FileReviewPanelPlacement>(() =>
    readFileReviewPanelPlacement(documentType)
  );

  useEffect(() => {
    const sync = () => setPlacement(readFileReviewPanelPlacement(documentType));
    const onStorage = (event: StorageEvent) => {
      if (!event.key || !event.key.startsWith('jarvis.fileReview.panelPlacement')) return;
      sync();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener(PLACEMENT_CHANGED_EVENT, sync);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(PLACEMENT_CHANGED_EVENT, sync);
    };
  }, [documentType]);

  return placement;
}
